import { useUiTranslator } from "../../hooks/useUiTranslator";

import { JSX } from "react";

import { Box } from "@mui/material";
import { useMatchRoute } from "@tanstack/react-router";

import { AppHeaderNavItem } from "./AppHeaderNavItem";
import { BtnReturnToProjectList } from "./BtnReturnToProjectList";

export interface INavItem {
  label: string;
  href: string;
  subItems: string[];
  isDummy?: boolean;
}

export function AppHeaderNav(): JSX.Element {
  const t = useUiTranslator();
  const matchRoute = useMatchRoute();
  const isConfigurator = matchRoute({ to: "/configurator" });

  const navDataArr: INavItem[] = [
    {
      label: t("CustomApp:buttons.header.returnToWEG", "Home"),
      href: t(
        "CustomApp:buttons.header.returnToWEG.url",
        "https://www.weg.net/catalog/weg/AT/en/Gearboxes-and-Geared-Motors/c/GLOBAL_GEARBOXES",
      ),
      subItems: [],
    },
    {
      label: t(
        "CustomApp:buttons.header.toProjectList",
        "Restart configuration",
      ),
      href: "/",
      subItems: [],
    },
  ];

  const navItemElements = navDataArr.map((navItem, index) => {
    return (
      <AppHeaderNavItem
        navItem={navItem}
        key={navItem.label + index}
        index={index}
        active={navItem.label === "Productfinder"}
      />
    );
  });

  return (
    <Box display="flex" alignItems="center">
      {navItemElements}
      {isConfigurator ? <BtnReturnToProjectList /> : <></>}
    </Box>
  );
}
